import React from 'react'
import moment from 'moment'
import { capitalize } from 'lodash'
import formatLeadPromoDesc from '../../utils/formatLeadPromoDesc'
import triggerCustomGaEvent from '../../utils/triggerCustomGaEvent'
import '../../styles/scss/components/equote-package-details-related-sailings-table.scss'
import '../../styles/scss/base/table.scss'
import { formatDisplayPrice } from '../../utils/formatPrice'
import TaxLine from '../TaxLine'
import Price from '../Price'

const renderPricing = (
  pricing,
  symbol = '$',
  placement = 'start',
  occupancy = 2
) => {
  if (
    !pricing ||
    !pricing.bestGuestCountRate ||
    !pricing.bestGuestCountRate.netPrice
  )
    return <div className="sold-out">Sold Out</div>

  const displayPrice = Number(
    pricing.bestGuestCountRate.netPrice / +occupancy
  ).toFixed(2)

  return (
    <div>
      {displayPrice ? (
        <>
          <div className="table-cell-text table-cell-text--price">
            <Price
              price={formatDisplayPrice(displayPrice)}
              currencySymbol={symbol}
              currencySymbolPlacement={placement}
            />
          </div>
          <div className="table-cell-text table-cell-text--promo">
            {formatLeadPromoDesc(
              pricing.bestGuestCountRate.leadPromoDesc,
              pricing.bestGuestCountRate.promos
            )}
          </div>
          <div className="table-cell-text table-cell-text--refundable">
            {pricing.bestGuestCountRate.isRefundable
              ? `Regular Deposit`
              : `Non-Refundable Deposit`}
          </div>
        </>
      ) : (
        <div className="sold-out">Sold Out</div>
      )}
    </div>
  )
}

const EQuotePackageRelatedSailingsTable = props => {
  const relatedSailings = props.sailings

  const handleRequest = sailing => {
    triggerCustomGaEvent('alternate-sail-date-request', {
      'date requested': sailing.sailDate
    })
    props.goToNextPage(sailing, props.requestAlternateSailing)
  }

  return (
    <div className="equote-package-related-sailings-table table-with-featured-image u-content-container">
      <div className="featured-image">
        <img src={props.brandDestinationImage} alt="Other Departures" />
      </div>

      <div
        style={{
          flex: 1
        }}
      >
        <table className="u-table">
          <thead>
            <tr>
              <th>Trip</th>
              <th>Interior</th>
              <th>Oceanview</th>
              <th>Balcony</th>
              <th>Deluxe / Suite</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {relatedSailings.map(sailing => {
              return (
                <tr key={sailing.identifier}>
                  <td>
                    <div className="table-cell-text--title">
                      {capitalize(sailing.tableDescription)}
                    </div>
                    <div>
                      Departure:{' '}
                      {moment(sailing.sailDate, 'YYYY-MM-DD').format(
                        'MMM DD, YYYY'
                      )}
                    </div>
                    <div>Ship: {sailing.shipName}</div>
                    {sailing?.taxes && (
                      <div style={{ fontSize: '12px', fontWeight: 'normal' }}>
                        <i>
                          <TaxLine
                            isBundlePricing={sailing.taxesFeesIncluded}
                            currencySymbol={sailing.currencySymbol || '$'}
                            currencySymbolPlacement={
                              sailing.currencySymbolPlacement || 'start'
                            }
                            currency={sailing.currency}
                            amount={sailing.taxes}
                          />
                        </i>
                      </div>
                    )}
                  </td>
                  <td>
                    <div>
                      {renderPricing(
                        sailing.guestCountPricing['I'],
                        sailing.currencySymbol,
                        sailing.currencySymbolPlacement,
                        props.occupancy
                      )}
                    </div>
                  </td>
                  <td>
                    <div>
                      {renderPricing(
                        sailing.guestCountPricing['O'],
                        sailing.currencySymbol,
                        sailing.currencySymbolPlacement,
                        props.occupancy
                      )}
                    </div>
                  </td>
                  <td>
                    <div>
                      {renderPricing(
                        sailing.guestCountPricing['B'],
                        sailing.currencySymbol,
                        sailing.currencySymbolPlacement,
                        props.occupancy
                      )}
                    </div>
                  </td>
                  <td>
                    <div>
                      {renderPricing(
                        sailing.guestCountPricing['D'],
                        sailing.currencySymbol,
                        sailing.currencySymbolPlacement,
                        props.occupancy
                      )}
                    </div>
                  </td>
                  <td>
                    <button
                      className="btn btn-primary not-allowed u-uppercase similar"
                      onClick={() => handleRequest(sailing)}
                    >
                      Request
                    </button>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default EQuotePackageRelatedSailingsTable
